/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.facilities.buildings'},
});

const BuildingsItem = () => (
  <RouteLinkItem
    route="midas/settings/facilities/buildings"
    title={messages.title}
  />
);

export default BuildingsItem;
